/**
 * DataZoom component entry
 */


    var echarts = require('../echarts');

    echarts.registerPreprocessor(require('./timeline/preprocessor'));

    require('./timeline/typeDefaulter');
    require('./timeline/timelineAction');
    require('./timeline/SliderTimelineModel');
    require('./timeline/SliderTimelineView');




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/timeline.js
// module id = 1464
// module chunks = 1